export default function Video() {
	const videos = document.querySelectorAll('.js-video')

	if (videos.length) {
		videos.forEach(function(item) {
			const video = {
				element: item,
				videoElement: item.querySelector('.js-video-source')
			}

			if (!video.videoElement) return

			video.src = video.videoElement.dataset.src

			video.element.addEventListener('click', function(e) {
				e.preventDefault()

				video.videoElement.classList.add('isActive')

				video.videoElement.src = video.src
			})
		})
	}
}
